import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import VuexORM from '@sbvr/lbe-orm';

Vue.use(Vuex);

const store: Store<any> = new Vuex.Store({
  plugins: [
    VuexORM({
      defineSchema (schema) {
        const User = new schema.Entity('User', {});
        return {
          User,
        };
      },
    }),
  ],
});

export function useStore (): Store<any> {
  return store;
}

export default store;
